import { useCallback } from 'react';

export default function useSelectedProduct(products) {
    const update = useCallback((attrs) => {
        products.selected && products.update(products.selected, attrs);
    }, [products.selected, products.update]);

    const deleteImage = useCallback((image) => {
        products.selected && products.deleteImage(products.selected, image);
    }, [products.selected, products.deleteImage]);

    const updateDefaultImage = useCallback((imageFile) => {
        products.selected && products.updateDefaultImage(products.selected, imageFile);
    }, [products.selected, products.updateDefaultImage]);

    return {
        get current() { return products.selected; },
        set current(value) { products.select(value); },
        update,
        deleteImage,
        updateDefaultImage,
    };
}
